import SiteContext from "./SiteContext";
import React, { useState } from "react";

const States = (props) => {
    const [clear, setClear] = useState(false);
    const [toggleFilter, setToggleFilter] = useState(false);
    const [toggleSearch, setToggleSearch] = useState(false);
    const [srno, setSrno] = useState(0);


    const clearTransactions = () => {
        setClear(!clear);
    }

    const handleFilter = () => {
        setToggleFilter(true);
    }

    const handleSearch = () => {
        setToggleSearch(true);
        setToggleFilter(false);
    }

    const handleSearchClose = () => {
        setToggleSearch(false);
    }

    return (
        <SiteContext.Provider value={{ clearTransactions, clear, setClear, handleFilter, toggleFilter, setToggleFilter, toggleSearch, setToggleSearch, handleSearch, handleSearchClose, srno, setSrno }}>
            {props.children};
        </SiteContext.Provider>
    )
}

export default States;